import { createContext, useContext, useState } from 'react';
import { jsx as _jsx } from "react/jsx-runtime";
const CustomerAgentHoverContext = /*#__PURE__*/createContext(undefined);
//This context gives us easy access to controlling the hover state and passing it down to the components that need it.
export const CustomerAgentHoverProvider = ({
  children,
  enableHoverTracking = false
}) => {
  const [isHoverActive, setIsHoverActive] = useState(false);

  // When hover tracking is disabled, hover state is always false and setters are no ops
  const _isHoverActive = enableHoverTracking ? isHoverActive : false;
  const _setIsHoverActive = enableHoverTracking ? setIsHoverActive : () => {};
  return /*#__PURE__*/_jsx(CustomerAgentHoverContext.Provider, {
    value: {
      isHoverActive: _isHoverActive,
      setIsHoverActive: _setIsHoverActive
    },
    children: children
  });
};
CustomerAgentHoverProvider.displayName = 'CustomerAgentHoverProvider';
export const useCustomerAgentHover = () => {
  const context = useContext(CustomerAgentHoverContext);
  if (context === undefined) {
    throw new Error('Hover must be used within a HoverProvider');
  }
  return context;
};